module.exports = __webpack_public_path__ + "media/eraser.8d658711.mp4";